module.exports = __webpack_public_path__ + "img/icon-info.4485ebb0.svg";